import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { CreateServiceRequest, PatchServiceRequest } from '@wf/shared'
import { api } from '../api/client'

export function useServicesList() {
  return useQuery({ queryKey: ['services'], queryFn: api.listServices })
}

// Leistungen tragen keine version (kein OCC wie Aufträge/Kunden) — eine Schreib-Mutation lädt die Liste
// einfach frisch nach. Das hält den Katalog konsistent, ohne Reconcile-Logik im UI.
function useServicesMutation<V>(run: (vars: V) => Promise<unknown>) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: run,
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['services'] }),
  })
}

export function useCreateService() {
  return useServicesMutation((body: CreateServiceRequest) => api.createService(body))
}
export function usePatchService() {
  return useServicesMutation((vars: { id: number; body: PatchServiceRequest }) => api.patchService(vars.id, vars.body))
}
export function useDeleteService() {
  return useServicesMutation((id: number) => api.deleteService(id))
}
